import type { SVGProps } from 'react';
import { palette } from '../tokens.ts';

const RED = '#A23B2C';
const BLUE = '#34506B';
const YELLOW = palette.fleetYellow;
const WHITE = '#F7F0DC';

/** A short string of signal flags dressing a line; small decorative accent. */
export function SignalBunting({
  color = palette.ink,
  ...rest
}: SVGProps<SVGSVGElement> & { color?: string }) {
  const flags = [
    [YELLOW, BLUE],
    [RED, WHITE],
    [BLUE, YELLOW],
    [WHITE, RED],
    [YELLOW, RED],
  ];
  return (
    <svg viewBox="0 0 160 40" width="160" height="40" aria-hidden="true" focusable="false" {...rest}>
      <path d="M0 6 Q80 22 160 6" fill="none" stroke={color} strokeWidth={0.8} />
      {flags.map(([a = WHITE, b = WHITE], i) => {
        const x = 14 + i * 28;
        const y = 6 + 16 * (1 - ((x - 80) / 80) ** 2) * 0.62;
        return (
          <g key={i} transform={`translate(${x} ${y})`} stroke={color} strokeWidth={0.6}>
            <rect x={-7} y={0} width={7} height={12} fill={a} />
            <rect x={0} y={0} width={7} height={12} fill={b} />
          </g>
        );
      })}
    </svg>
  );
}
